"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeIsHidden = nodeIsHidden;
const textBoolean_1 = require("./textBoolean");
function nodeIsHidden(node) {
    if (node.values.includes('hide')) {
        return true;
    }
    const hideNode = node.nodes.find((n) => n.name === 'hide');
    return hideNode ? (0, textBoolean_1.textBoolean)(hideNode.values[0]) : false;
}
//# sourceMappingURL=nodeIsHidden.js.map